import { MenuItem, ActionButton, Menu, MenuTrigger } from "@react-spectrum/s2";
import React from 'react';
import { More } from '../icons/s2';

export interface RowAction {
  key: string;
  label: string;
  onAction: () => void;
  isDisabled?: boolean;
}

export interface RowActionsMenuProps {
  /** Accessible name for the kebab trigger, e.g. "Actions for user-1". */
  ariaLabel: string;
  actions: RowAction[];
  isDisabled?: boolean;
}

/**
 * Kebab (⋮) trigger + popover menu for a table row with more than one action.
 * Keeps per-row action icons from competing with the row data for attention.
 */
export function RowActionsMenu({ ariaLabel, actions, isDisabled }: RowActionsMenuProps) {
  if (!actions.length) return null;
  return (
    <MenuTrigger>
      <ActionButton isQuiet aria-label={ariaLabel} isDisabled={isDisabled}>
        <More />
      </ActionButton>
      <Menu
        onAction={(key) => actions.find((a) => a.key === key)?.onAction()}
        disabledKeys={actions.filter((a) => a.isDisabled).map((a) => a.key)}
      >
        {actions.map((a) => (
          <MenuItem id={a.key} key={a.key}>{a.label}</MenuItem>
        ))}
      </Menu>
    </MenuTrigger>
  );
}
